<svelte:head>

    <link rel="stylesheet" type="text/css" href="/global.css" />
    <link rel="stylesheet" type="text/css" href="/css/forms.css" />

</svelte:head>

<script>

    import { createEventDispatcher } from "svelte";
    import { Dropdown } from "carbon-components-svelte";
    import { fade } from 'svelte/transition';

    import {
        errorReasons
    } from "../api.svelte";


    const dispatch = createEventDispatcher();

    export let propertyData = false;
    export let formError = false;
    export let isLoading = false;
    export let isSuccessful = false;
    export let tight = false;

    let title = (!propertyData) ? '' : propertyData['details']['name'];
    let address = (!propertyData) ? '' : propertyData['details']['address'];
    let city = (!propertyData) ? '' : propertyData['details']['city'];
    let zip = (!propertyData) ? '' : propertyData['details']['zip'];
    let country = (!propertyData) ? 'switzerland' : propertyData['details']['country'];
    let category = (!propertyData) ? 'restaurant' : propertyData['businesstype'];

    $: getButtonText = () => {

        return (isSuccessful) ? 'Gespeichert' : 'Speichern';
    };


    const onSaveClicked = () => {

        let details = {
            'name': title,
            'address': address,
            'city': city,
            'zip': zip,
            'country': country
        };

        dispatch('saved', {
            details: details,
            category: category
        });

    };

</script>


<form
        on:submit|preventDefault={() => onSaveClicked()}
        id="locationform"
        class="forms {(tight ? 'tight' : '')} {(isSuccessful ? 'success' : '')}">

    <div id="formtitle">

        Informationen zum Standort

    </div>

    {#if formError}

        <div transition:fade id="error">

            {errorReasons[formError]}

        </div>

    {/if}

    <div class="input-title">

        Name des Standorts

    </div>

    <input
            bind:value={title}
            name="title"
            type="text"
            placeholder="Name" />

    <div class="input-title">

        Adresse des Standorts

    </div>

    <input
            bind:value={address}
            name="address"
            type="text"
            placeholder="Strasse" />

    <div class="double-input">

        <input
                bind:value={city}
                name="city"
                type="text"
                placeholder="Ort" />

        <input
                bind:value={zip}
                name="zip"
                type="text"
                placeholder="PLZ" />

    </div>

    <Dropdown
            class="forms-dropdown"
            bind:selectedId={country}
            items={[
                    { id: "switzerland", text: "Schweiz"},
                    { id: "germany", text: "Deutschland"},
                    { id: "austria", text: "Österreich"}
                ]}
    />

    <div class="input-title">

        Typ des Standorts

    </div>

    <Dropdown
            class="forms-dropdown"
            bind:selectedId={category}
            items={[
                    { id: "restaurant", text: "Restaurant"},
                    { id: "bar", text: "Bar"},
                    { id: "cafe", text: "Café"},
                    { id: "hotel", text: "Hotel"},
                    { id: "other", text: "Andere"},
                ]}
    />

    <button
            class={(isLoading) ? 'loading btn' : 'btn'}>

        <span>{getButtonText()}</span>
        <img src="/images/button-loader.svg" />

    </button>

</form>


<style>

    #formtitle {
        margin-bottom: 4.44vh;
        font-family: 'Raleway', sans-serif;
        font-size: 1.85vh;
        font-weight: 500;
    }

    #error {
        width: 28vh;
        padding: 1.78vh;
        margin-bottom: 2.67vh;
        font-size: 1.8vh;
    }

    .input-title {
        margin-bottom: 0.92vh;
        font-family: 'Raleway', sans-serif;
        font-size: 1.48vh;
        font-weight: 400;
        text-align: left;
    }

    input, button,
    :global(.forms-dropdown button),
    :global(.forms-dropdown .bx--list-box__menu) {
        width: 28.6vh;
        padding: 1.42vh;
        margin-bottom: 2.5vh;
        font-size: 1.78vh;
    }

    .tight input,
    .tight button,
    .tight :global(.forms-dropdown button),
    .tight :global(.forms-dropdown .bx--list-box__menu) {
        margin-bottom: 1.75vh;
    }

    input[name="city"] {
        width: 16.9vh;
        margin-right: 1.2vh;
    }

    input[name="zip"] {
        width: 6.86vh;
    }

    :global(.forms-dropdown .bx--list-box__menu) {
        margin-bottom: 0;
        top: 5.5vh;
    }

    :global(.forms-dropdown .bx--list-box__menu-item) {
        margin-bottom: 1vh;
    }

    :global(.forms-dropdown .bx--list-box__menu-item:last-child) {
        margin-bottom: 0;
    }

    button {
        width: 31.46vh;
        margin-bottom: 0;
    }

</style>
